import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import store from "src/storeWire";
import System from "../../helper/system";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import AxiosSingletonLoader from 'src/component/Global/AxiosSingletonLoader';
import { __remove, __set } from 'src/store/axios_indicator';
import { SET_ADD_CART_DATA } from 'src/store/slice/model/Cart';
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import Constants from 'src/helper/Constants';
// import { useProductStore } from 'src/hooks/product';
import useReduxState from 'src/hooks/useReduxState';
import { useProductStore } from 'src/hooks/product';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import liveAuth from 'src/helper/liveAuth';

const AddToCart = (props) => {
    const addToCartButtonRef = useRef(null);
    const { single_product, isCompactView, isCompactViewHide, isHideAddToCart, isHideContactUs, single_product_inventory, single_product_pricing_list, isFrom, do_not_display_add_to_cart_button = false, isObsoleteProduct = false, isFromManualCart = false } = props;
    const [disabled_add_to_cart_button, set_disabled_add_to_cart_button] = useState(false);
    const [{ CART_DATA, CART_BEFORE_TO_SEND_SERVER, ADD_CART_DATA }, { fetch_cart_data, check_item_exists_in_cart, get_display_status_button, backorder_not_available, get_Validate_Cart_From_Server }, { ADD_TO_CART }] = useCartStore();
    const [{ }, { get_pricing_by_id, get_current_price_by_quantity }, { }] = useProductInventoryPriceStore();
    const [{ }, { get_product_assets }, { }] = useProductStore();
    const [addToCartSingleClick, setAddToCartSingleClick] = useReduxState({}, 'addToCartSingleClick')
    const add_cart_data = ADD_CART_DATA;

    const [load, setLoad] = useState(false);
    const ItemNumber = single_product.ItemNumber;
    const [disableCart, setDisableCart] = useState(0);
    const [__check] = useAxiosIndicatorCheck();
    const orderBlock = System.avUserInfoData.orderBlock;
    const { systemModules: { CART, PDP, ADDTOCART }, speedBoats: { japanAbbr } } = Constants
    const { translation: t } = System;
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')

    useEffect(() => {
        async function fetchHere() {
            let status = false;
            const _product = CART_BEFORE_TO_SEND_SERVER[ItemNumber];

            if (_product && _product.invalid_quantity) {
                status = true;
            }
            if (isObsoleteProduct) {
                status = true;
            }
            set_disabled_add_to_cart_button(status)
        }

        fetchHere()
    }, [CART_BEFORE_TO_SEND_SERVER[ItemNumber], isObsoleteProduct])

    useEffect(() => {
        if (!add_cart_data) {
            setLoad(add_cart_data)
            __remove('CART_API_CALL');
        }
        if (add_cart_data && !load) {
            setLoad(add_cart_data);
        }
    }, [add_cart_data])

    const addToCartServer = async () => {
        setAddToCartSingleClick({ ...addToCartSingleClick, [single_product.ItemNumber]: { clicked: true } })
        __set('ADD_TO_CART_API_CALL');
        setDisableCart(ItemNumber)
        setLoad(true);

        if (disabled_add_to_cart_button) {
            setLoad(false);
            setDisableCart(0)
            __remove('ADD_TO_CART_API_CALL');
            return false;
        }

        await get_product_assets({ [single_product.ItemNumber]: single_product }, { isPriceCall: false, isFrom: ADDTOCART })

        // if (Object.entries(CART_DATA).length === 0) {
        //     await fetch_cart_data({ minicart: true, shipToAddressId: System.getUserShippingAddress() });
        // }

        setLoad(true);

        setTimeout(async () => {
            let state = store.getState();
            let isInvalidQty = state.entities.Cart.CART_BEFORE_TO_SEND_SERVER[ItemNumber].invalid_quantity;

            if (!isInvalidQty) {
                store.dispatch(SET_ADD_CART_DATA(true));
                await addToCart();
            }
            __remove('ADD_TO_CART_API_CALL');
            setDisableCart(0)
        }, 200);

    };

    const addToCart = async () => {
        if (single_product.ItemNumber) {
            let state = store.getState();
            let inputQty = getQuantityAddToCart();
            const productQty = state.entities.model_ProductInventoryPrice.inventory_list[single_product.ItemNumber].totalInventory
            const currentPrice = get_current_price_by_quantity(get_pricing_by_id({ ItemNumber: single_product.ItemNumber }), inputQty, true)

            let cartList = CART_DATA

            if (!cartList[ItemNumber]) {
                let state = store.getState();
                cartList = state.entities.Cart.CART_DATA;
            }
            // let cartQty = cartList[ItemNumber]?.quantity ? cartList[ItemNumber].quantity : 0

            // let totalQuantity = inputQty + cartQty; //after added to cart quantity

            // let backOrderedQuantity = totalQuantity;
            // if (productQty) {
            //     backOrderedQuantity = (totalQuantity - productQty) < 0 ? 0 : totalQuantity - productQty;
            // }

            let productParam = {
                "quantity": inputQty,
                // "backOrderedQuantity": backOrderedQuantity || 0,
                "VendorCode": single_product.VendorCode,
                "SAPMatGroup": single_product.SAPMatGroup,
                "partNumber": single_product.ERPPartNumber,
                "ItemNumber": single_product.ItemNumber,
                "ManufacturerPartNumber": single_product.ManufacturerPartNumber,
                "ManufacturerCode": single_product.ManufacturerCode,
                "ManufacturerName": single_product.ManufacturerName,
                "AssetURL": single_product.AssetURL,
                "type": "Shopping",
                "ERPMFRPartNumber": single_product.ERPMFRPartNumber,
                "ERPManufacturerName": single_product.ERPManufacturerName,
                "ERPManufacturerCode": single_product.ERPManufacturerCode,
                // "totalQuantity": totalQuantity,
                "addedFromBom": false,
                "default_plant": single_product.default_plant,
                "mdmMaterialId": single_product.MDMMaterialID,
                "ERPSupplierCode": single_product.ERPSupplierCode,
                "seoItemNumber": single_product.seoItemNumber,
                'currentStock': productQty,
                'isBackOrder': false,
                'isReplace': false,
                'unitPrice': Number(currentPrice.marketPrice)
            }

            if (isFromManualCart && single_product?.selectedSearchCPN) { // condition execute when search part using CPN from manually add part from cart
                productParam.cpn = single_product?.selectedSearchCPN
            } else if (CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]?.CPN) {
                productParam.cpn = CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]?.CPN
                // productParam.endCustAccNum = get_end_customer_by_cpn(single_product.CustomerPartNumbers, CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]?.CPN)
            }

            // if (props?.dontOpenAddedToCartPopup) {
            //     productParam.dontOpenAddedToCartPopup = true;
            // }

            let data = {
                "ShortDescription": single_product?.ShortDescription,
                'ObsoleteFlag': single_product?.ObsoleteFlag,
                'EndOfLifeFlag': single_product?.EndOfLifeFlag,
                'specialPriceFlag': single_product?.specialPriceFlag,
                'constrainPartFlag': single_product?.constrainPartFlag,
                'ExcessInventoryFlag': single_product?.ExcessInventoryFlag,
                'FactoryLeadTime': single_product?.FactoryLeadTime
            }

            const res = await ADD_TO_CART(productParam, isFrom, data, isFromManualCart);
            productParam = { ...productParam, subTotal: res?.data?.subtotal, unitPrice: res?.data?.unitPrice };
            !res?.data?.isBackOrderConfirmation && HelperAnalyticsEvent.addToCartEvent({ productObj: productParam, pricingObj: single_product_pricing_list?.[0], cartId: res?.data?.cartId, isFrom: isFrom });
            if (res?.data && res?.isSuccessFull && props?.productAddedToCartCallback) {
                props.productAddedToCartCallback();
                if (isFrom === CART && !res?.data?.isBackOrderConfirmation) {
                    get_Validate_Cart_From_Server()
                }
            }

            // let checkExistingItemResponse = false

            // if (CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]?.CustomerPartNumbers?.length > 0) {
            //     checkExistingItemResponse = await check_item_exists_in_cart({
            //         items: [{
            //             itemNumber: single_product.ItemNumber,
            //             cpn: CART_BEFORE_TO_SEND_SERVER[ItemNumber].CPN || ''
            //         }]
            //     });
            // }
            // if ((backOrderedQuantity > 0 && backorder_not_available(single_product))) {
            //     System.popup('BackorderNotAvailable', { singleProduct: productParam })
            //     if (isFromManualCart === true) {
            //     setProductSelected({})
            //     setSearchTerm('')
            //     setTimeout(() => {
            //         document.body.style.overflow = '';
            //     }, 400)
            // }
            // } else if (checkExistingItemResponse === true) {
            //     // different CPN is exist in cartList that time replace CartItem will call
            //     backOrderedQuantity = (inputQty - productQty) < 0 ? 0 : inputQty - productQty;

            //     productParam = {
            //         "quantity": getQuantityAddToCart(),
            //         "currency": System.getRegionCurrency(),
            //         "backOrderedQuantity": backOrderedQuantity || 0,
            //         "cpn": CART_BEFORE_TO_SEND_SERVER[ItemNumber].CPN || '',
            //         "VendorCode": single_product.VendorCode,
            //         "SAPMatGroup": single_product.SAPMatGroup,
            //         "partNumber": single_product.ERPPartNumber,
            //         "ItemNumber": single_product.ItemNumber,
            //         "ManufacturerPartNumber": single_product.ManufacturerPartNumber,
            //         "ManufacturerCode": single_product.ManufacturerCode,
            //         "ManufacturerName": single_product.ManufacturerName,
            //         "AssetURL": single_product.AssetURL,
            //         "type": "Shopping",
            //         "ERPMFRPartNumber": single_product.ERPMFRPartNumber,
            //         "ERPManufacturerName": single_product.ERPManufacturerName,
            //         "ERPManufacturerCode": single_product.ERPManufacturerCode,
            //         "totalQuantity": totalQuantity,
            //         "seoItemNumber":single_product.seoItemNumber
            //     }
            //     System.popup('CartItemReplacePopup', {
            //         cartReplaceItem: productParam,
            //         productAddedToCartCallback: props.productAddedToCartCallback,
            //         isFrom: isFrom
            //     })
            // } else {
            //     // check only if backorder quantity is greater than 0 and already backorder is not in cart
            //     // if (backOrderedQuantity > 0 && !single_product?.SoftwareDownloadFlag) {
            //     if (backOrderedQuantity > 0) {
            //         let data = [{
            //             "quantity": inputQty,
            //             "ERPPartNumber": single_product.ERPPartNumber,
            //             "ItemNumber": single_product.ItemNumber,
            //             "ManufacturerPartNumber": single_product.ManufacturerPartNumber,
            //             "ManufacturerName": single_product.ManufacturerName,
            //             "FactoryLeadTime": single_product?.FactoryLeadTime,
            //             "ShortDescription": single_product?.ShortDescription,
            //             "totalQuantity": totalQuantity,
            //             "backOrderedQuantity": backOrderedQuantity || 0,
            //             "ERPMFRPartNumber":single_product.ERPMFRPartNumber,
            //             // "cartId": v.cartId,
            //             // "cartDetailId": v.cartDetailId
            //             "seoItemNumber": single_product.seoItemNumber
            //         }]

            //         {(System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, Constants.siteUser.WEB) || !liveAuth.check()) ? System.popup('BackorderNotAvailable', { singleProduct: productParam }) :
            //         System.popup('InventoryAlertForAddToCartPopup', { single_product: data, isFrom: isFrom, addToCartParam: productParam, isFromManualCart })}

            //     } else {
            //         const res = await ADD_TO_CART(productParam, (isFrom === CART));
            //         productParam = {...productParam, subTotal: res?.data?.subtotal, unitPrice: res?.data?.unitPrice};
            //         HelperAnalyticsEvent.addToCartEvent({ productObj: productParam, pricingObj: single_product_pricing_list?.[0], cartId: res?.data?.cartId, isFrom: isFrom });
            //         if (res?.data && res?.isSuccessFull && props?.productAddedToCartCallback) {
            //             props.productAddedToCartCallback();
            //             if (isFrom === CART) {
            //                 get_Validate_Cart_From_Server()
            //             }
            //         }
            //     }

            // }
        }
    };

    const getQuantityAddToCart = () => {
        return CART_BEFORE_TO_SEND_SERVER[ItemNumber]?.quantityUpdateToCart ? CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityUpdateToCart : 0
    };

    const getDisplayStatusOfAddToCart = () => {
        return get_display_status_button(single_product, single_product_pricing_list, single_product_inventory, 'cart')
    };

    const getDisplayStatusOfContactUsButton = () => {
        return get_display_status_button(single_product, single_product_pricing_list, single_product_inventory, 'contactUs')
    };

    const openContactPopup = (val) => {
        System.popup('ContactPopup', { isFromManualCart: true })
    };

    const customAxiosIndicatorRunTimeLoader = () => {
        return (
            load &&
            <a href={void (0)} disabled={true}
                className={!isCompactView ? "bs5 btn btn-primary btn-sm w-100 disabled" : "bs5 btn btn-primary btn-sm w-100 disabled"}>
                <i className="fa fa-spinner fa-spin" />
            </a>
        )
    };


    const getContactUsButton = () => {
        if (isFrom === CART) {
            return (
                <div onClick={() => { openContactPopup() }}>
                    <button className="bs5 btn btn-primary btn-sm w180 h30">
                        {t('contactUs')}
                    </button>
                </div>
            )
        }
        return (
            <button onClick={() => { openContactPopup() }}
                className={!isCompactView && !isCompactViewHide ? 'bs5 btn btn-primary w-100 click-to-quote-btn' : 'bs5 btn btn-primary click-to-quote-btn'}
            > {t('contactUs')}
            </button>
        )
    };
    const get_AxiosSingletonLoader_disabled_add_to_cart_button = () => {
        let flag = !!(single_product?.ObsoleteFlag && single_product_inventory?.quantity > 0 && (getQuantityAddToCart() > single_product_inventory?.quantity));
        if (flag) {
            return true;
        }

        return disabled_add_to_cart_button;
    };
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);

    const result_AxiosSingletonLoader_disabled_add_to_cart_button = useMemo(() => {
        return get_AxiosSingletonLoader_disabled_add_to_cart_button();
    }, [disabled_add_to_cart_button, single_product, single_product_inventory, CART_BEFORE_TO_SEND_SERVER, axios_indicator]);

    return (
        <div>
            {getDisplayStatusOfAddToCart() && !do_not_display_add_to_cart_button &&
                <>
                    <AxiosSingletonLoader disabled={result_AxiosSingletonLoader_disabled_add_to_cart_button}
                        slugKey={['ADD_TO_CART_API_CALL', 'CART_OPERATION_API_CALL', 'VIEW_CART_API_CALL']}
                        customAxiosIndicatorRunTimeLoader={() => { return customAxiosIndicatorRunTimeLoader() }}>

                        {/* display add to cart based on active permission */}
                        {!isHideAddToCart &&
                            <>
                                {/* manually add to cart */}
                                {isFrom === CART ?
                                    <div ref={addToCartButtonRef} onClick={async () => { await addToCartServer(); }}>
                                        <button className={disabled_add_to_cart_button ? "bs5 btn btn-secondary btn-sm w180 h30 disabled" : "bs5 btn btn-secondary btn-sm w180 h30"}>
                                            {t('updateCart')?.toUpperCase?.()}
                                        </button>
                                    </div>
                                    : ((__check(['ADD_TO_CART_API_CALL']).status && disableCart == ItemNumber) ?
                                        <a href={void (0)} disabled={true}
                                            className="bs5 btn btn-primary btn-sm w-100 disabled">
                                            <i className="fa fa-spinner fa-spin" />
                                        </a> :
                                        <a ref={addToCartButtonRef}
                                            onClick={async () => { await addToCartServer(); }}
                                            className={`bs5 btn btn-primary btn-sm ${isCompactView ? 'w-100 add-to-cart-icon' : "condense-add-to-cart"}`}>
                                            {System.getCurrentRegionWithType(japanAbbr) ?
                                                <>
                                                    <i className={"fa fa-shopping-cart font-14"} />
                                                    {isCompactView ? "" : t('addTo')}
                                                </> :
                                                <>
                                                    {isCompactView ? "" : t('addTo')}
                                                    <i className={"fa fa-shopping-cart font-14"} />
                                                </>
                                            }
                                        </a>)
                                }
                            </>
                        }

                    </AxiosSingletonLoader>
                </>
            }

            {/* display contact us button */}
            {getDisplayStatusOfContactUsButton() && !isHideContactUs &&
                <>
                    {getContactUsButton()}
                </>
            }

        </div>
    );
};

export default AddToCart;